import React from 'react';
import { Icon } from './Icon.js';
export const IconCopies2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "7", width: "14", height: "9", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("path", { d: "M5.75,2.5h6.5c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75H5.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M4.25,5.5H13.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75H4.25c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconCopies2Fill18.js.map